import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { EtiquetaModule } from '../modelo/etiqueta/etiqueta.module';


@Injectable({
  providedIn: 'root'
})
export class ConfigetiquetaService {

  constructor(private http: HttpClient) { }

  actualizar(etiqueta :EtiquetaModule)
  {

    return this.http.put(environment.apiUrl+"actualizarEtiqueta/",etiqueta); 
   }

   registrar(etiquetas :EtiquetaModule[])
  {

    return this.http.put(environment.apiUrl+"actualizarEtiqueta/",etiquetas); 
   }


   eliminar(entidad:EtiquetaModule)
   {
 
     return this.http.put(environment.apiUrl+"eliminarEtiqueta/",entidad); 
    }
 

  listar()
  {

    return this.http.get(environment.apiUrl+"listaEtiquetas/"); 
   }

   etiquetaxProducto(producto:string)
  {

    return this.http.get(environment.apiUrl+"listaEtiquetaxPorducto/"+producto); 
   }


   listarProducto()
  {

    return this.http.get(environment.apiUrlFlp+"listaProductos/"); 
   }

   listarCliente()
  {

    return this.http.get(environment.apiUrlFlp+"listaCliente/"); 
   }

   listarConfigEtiqueta()
  {

    return this.http.get(environment.apiUrl+"listarConfiEtiqueta/"); 
   }

   configEtiqueta(id:number,lote:string)
   {
 
     return this.http.get(environment.apiUrl+"configEtiqueta/"+id+"/"+lote); 
    }
}
